import {inject, Injectable} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import {UvtService} from "./uvt.service";

export enum Icons {
    PATRIMONIO = 'patrimonio',
    INGRESOS = 'ingresos',
    CONSUMOS_TC = 'consumos',
    COMPRAS = 'compras',
    CONSIGNACIONES = 'consignaciones',
    RESPONSABLE_IVA = 'responsable',
}

export interface ICondition {
    icon: Icons,
    ident: number,
    html: SafeHtml,
    html2?: SafeHtml,
    label: string,
    checked: boolean
}

export interface IIdent {
    ident1: boolean,
    ident2: boolean,
    ident3: boolean,
    ident4: boolean,
    ident5: boolean,
    ident6: boolean
}

@Injectable({
  providedIn: 'root'
})
export class ConditionsService {


    conditions: ICondition[] = [
        /*{ icon: Icons.PATRIMONIO, label: 'Patrimonio', ident: 2, html: 'Tuvo un patrimonio bruto superior a <strong><span>$190.854.000 COP</span></strong>&nbsp;<strong><span>(4.500 UVT)</span></strong> a 31 de diciembre de 2023', html2: 'Su patrimonio bruto a 31 de diciembre de 2023 fue igual o superior a <strong><span>$190.854.000 COP</span></strong>&nbsp;<strong><span>(4.500 UVT)</span></strong>', checked: true },
        { icon: Icons.INGRESOS, label: 'Ingresos', ident: 1, html: 'Tuvo ingresos brutos iguales o superiores a <strong class="inline-block">$59.376.800 COP </strong><strong class="inline-block">(1.400 UVT)</strong> durante el 2023', checked: true},
        { icon: Icons.CONSUMOS_TC, label: 'Consumos tarjeta de crédito', ident: 3, html: 'Hizo consumos de tarjeta de crédito superiores a <strong>$59.376.800 COP</strong>&nbsp;<strong><span>(1.400 UVT)</span></strong> durante el 2023', checked: false },
        { icon: Icons.CONSIGNACIONES, label: 'Consignaciones bancarias', ident: 4, html: 'Hizo consignaciones bancarias, depósitos o inversiones financieras por valor total o superior a <strong>$59.376.800 COP</strong>&nbsp;<strong><span>(1.400 UVT)</span></strong> durante el 2023', checked: true },
        { icon: Icons.COMPRAS, label: 'Compras', ident: 5, html: 'Hizo compras y consumos totales superiores a <strong>$59.376.800 COP</strong>&nbsp;<strong><span>(1.400 UVT)</span></strong> durante el 2023', checked: true },
        { icon: Icons.RESPONSABLE_IVA, label: 'Responsable de IVA', ident: 6, html: `Fue responsable de impuesto sobre las ventas <span>(IVA) a 31 </span>de diciembre de ${vigencia}`, checked: true },*/
    ];
    uvtValues : any;
    private uvtService = inject(UvtService);
    constructor() {
    }

    getConditions(): Observable<ICondition[]> {
        this.cargarConditions();
        return of(this.conditions);
    }

    private cargarConditions() {
        const vigencia = new Date().getFullYear()-1;
        const valueUvt = this.uvtService.uvtValues;
        const uvtPatrimonio = this.formateaNumero(valueUvt.patrimonio, false, false);
        const uvtOtros = this.formateaNumero(valueUvt.ingresos, false, false);
        const valorUvtPatrimonio = this.formateaNumero(valueUvt.valor * valueUvt.patrimonio, true, true);
        const valorUvtOtros = this.formateaNumero(valueUvt.valor * valueUvt.ingresos, true, true);

        this.conditions =  [
            { icon: Icons.PATRIMONIO,
                label: 'Patrimonio', ident: 2,
                html: `Tuvo un patrimonio bruto superior a <strong>${valorUvtPatrimonio} COP</strong>&nbsp;<strong>(${uvtPatrimonio} UVT)</strong> a 31 de diciembre de ${vigencia}`,
                html2: `Su patrimonio bruto a 31 de diciembre de ${vigencia} fue igual o superior a <strong>${valorUvtPatrimonio} COP</strong>&nbsp;<strong>(${uvtPatrimonio} UVT)</strong>`,
                checked: true },
            { icon: Icons.INGRESOS,
                label: 'Ingresos', ident: 1,
                html: `Tuvo ingresos brutos iguales o superiores a <strong>${valorUvtOtros} COP </strong><strong >(${uvtOtros} UVT)</strong> durante el ${vigencia}`,
                checked: true},
            { icon: Icons.CONSUMOS_TC,
                label: 'Consumos tarjeta de crédito', ident: 3,
                html: `Hizo consumos de tarjeta de crédito superiores a <strong>${valorUvtOtros} COP</strong>&nbsp;<strong>(${uvtOtros} UVT)</strong> durante el ${vigencia}`,
                checked: false },
            { icon: Icons.CONSIGNACIONES,
                label: 'Consignaciones bancarias', ident: 4,
                html: `Hizo consignaciones bancarias, depósitos o inversiones financieras por valor total o superior a <strong>${valorUvtOtros} COP</strong>&nbsp;<strong>(${uvtOtros} UVT)</strong> durante el ${vigencia}`,
                checked: true },
            { icon: Icons.COMPRAS,
                label: 'Compras', ident: 5,
                html: `Hizo compras y consumos totales superiores a <strong>${valorUvtOtros} COP</strong>&nbsp;<strong>(${uvtOtros} UVT)</strong> durante el ${vigencia}`,
                checked: true },
            { icon: Icons.RESPONSABLE_IVA, label: 'Responsable de IVA', ident: 6,
                html: `Fue responsable de impuesto sobre las ventas <span>(IVA) a 31 </span>de diciembre de ${vigencia}`, checked: true },
        ];
    }
    formateaNumero(valorNumerido: number, conSimbolo: boolean, redondear: boolean): string {

        const valor = redondear
            ? Math.round(valorNumerido / 1000) * 1000
            : valorNumerido;

        return new Intl.NumberFormat('es-CO', {
            style: conSimbolo ? 'currency' : 'decimal',
            currency: 'COP',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(valor);
    }
}
